import { useState } from 'react';
import { Settings } from '@mui/icons-material';
import { Stack } from '@mui/material';
import Button from 'domains/core/components/Button';
import PageLayout from 'domains/core/components/PageLayout';
import SearchField from 'domains/core/components/SearchField';
import useGetUsersList from 'hooks/queries/useGetUsersList';
import UsersTable from './UsersTable';

const UsersPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const { data, isLoading } = useGetUsersList({
        limit: 50,
        offset: 0,
        searchTerm: searchTerm.trim() || undefined,
    });
    const users = data?.data ?? [];

    const headerOthers = (
        <Stack direction="row" spacing={0} alignItems="center">
            <SearchField
                placeholder="Search users..."
                tooltipText="Search users by name, email, or role..."
                value={searchTerm}
                onChange={setSearchTerm}
                dataTestId="access-center-users-search-input"
            />
        </Stack>
    );

    const handleAssignRole = () => {
        // TODO: open Assign Role flow
    };

    const headerAction = (
        <Button variant="outlined" onClick={handleAssignRole} data-testid="access-center-users-assign-role-button">
            Assign Role
        </Button>
    );

    return (
        <Stack data-testid="access-center-users-page" role="main" aria-label="Users and roles - Users">
            <PageLayout
                header="Users"
                headerIcon={<Settings fontSize="inherit" />}
                headerOthers={headerOthers}
                headerAction={headerAction}
            >
                <UsersTable users={users} isLoading={isLoading} />
            </PageLayout>
        </Stack>
    );
};

export default UsersPage;
